// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/visual-illusions.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/visual-illusions/visual-illusions.js';

mount([g0]);
